const PersonalInfoSchema = {
  customerAddress: [{
    rule: 'required',
    error: 'The input field is required',
  }],
};

export default PersonalInfoSchema;
